import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { UserModel } from 'src/app/core/models/user.model';
import { UserService } from 'src/app/core/services/user.service';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';

@Component({
  selector: 'dum-registro-usuario-publico',
  templateUrl: './registro-usuario-publico.component.html',
  styleUrls: ['./registro-usuario-publico.component.scss']
})
export class RegistroUsuarioPublicoComponent extends BaseComponent implements OnInit {
  @ViewChild('registroUsuarioForm') form: NgForm;
  @ViewChild('telefono') telefono: Input;
  @Input() newUser: UserModel = new UserModel();
  @Input() hasVehiculo: boolean;
  contrasenaRepetida: string = '';
  mensajeErrorEmail: boolean = false;
  mensajeErrorTelefono: boolean = false;
  mensajeErrorNif: boolean = false;
  validForm: boolean = true;
  @Output() eventSiguiente: EventEmitter<UserModel> = new EventEmitter<UserModel>();
  @Output() eventHasVehiculo: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  validateEmail() {
    const re = /^(([^<>()[\]{}'^?\\.,!|//#%*-+=&;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (re.test(this.newUser.email)) {
      this.mensajeErrorEmail = false;
      return true;
    }
    else {
      this.mensajeErrorEmail = true;
      return false;
    }
  }

  validateNIF() {
    const patron1 = /[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][A-Z]$/;
    const patron2 = /[A-Z][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
    if (patron1.test(this.newUser.nif) || patron2.test(this.newUser.nif)) {
      this.mensajeErrorNif = false;
      return true;
    } else {
      this.mensajeErrorNif = true;
      return false;
    }
  }

  siguienteRegistro() {
    if (this.form.invalid || !this.validateNIF() || !this.validateEmail()) {
      this.validForm = false;
    } else {
     this.eventHasVehiculo.emit(this.hasVehiculo);
     this.eventSiguiente.emit(this.newUser);
    }
  }
}
